import { InputSwitch } from 'primereact/inputswitch'
import { InputText } from 'primereact/inputtext'
import { useNavigate } from 'react-router-dom'

import { Icon, PageHeader } from '../../../Components'
import { FC } from '../../../Services'
import { cap } from '../../../State'
import { translations } from '../../../translations'
import { alert } from '../Functions'
import { SearchByClient } from '../Search/SearchByClient'
import { SearchByGroup } from '../Search/SearchByGroup'

const language = cap.language.state || 'IT'
const t = translations[language]

const HeaderSettings = ({
  presetId,
  clientCode: [clientCode, setClientCode],
  selectedClient: [selectedClient, setSelectedClient],
  save,
  codiceGruppo: [codiceGruppo, setCodiceGruppo],
  descrizioneGruppo: [descrizioneGruppo, setDescrizioneGruppo],
  group: [group, setGroup],
  titolo: [titolo, setTitolo],
  ragioneSociale: [ragioneSociale, setRagioneSociale],
  defaultPreset: [defaultPreset, setDefaultPreset],
  initialDefaultPreset: [initialDefaultPreset, setInitialDefaultPreset],
  visibilityCondition,
  operation,
  statePreset: [statePreset, setStatePreset],
  selectedTypeSearch: [selectedTypeSearch, setSelectedTypeSearch],
  isSaving = false
}) => {
  const navigate = useNavigate()
  const handleSearch = async () => {
    const hasEmptyClientCodeValues = Object.values(clientCode).some((v) => !v)
    if (hasEmptyClientCodeValues) {
      if (!codiceGruppo && !descrizioneGruppo) {
        return alert('error', t.errore, t.cpInserisciParametroRicerca)
      }

      const groupSearch = await FC.service('info').get('getGroups', {
        query: { codice: codiceGruppo }
      })

      if (!groupSearch.success && codiceGruppo !== 'DEFAULT') {
        return alert('error', t.cpErroreRicercaGruppo, groupSearch.errorMessage)
      }
      if (!groupSearch.found && codiceGruppo !== 'DEFAULT') {
        return alert('error', t.cpGruppoNonTrovato, '')
      }
      const presetExists = await checkPresetEsistente('gruppo')
      if (presetExists) {
        setGroup()
        alert('warn', t.cpPresetEsistente, t.cpGruppoConfigurazioneEsistente)
        if (operation !== 'duplicate') {
          return navigate('/community/panel/' + presetExists.id)
        }
      }

      return setGroup(groupSearch)
    }

    setSelectedClient()

    const { mastro, gruppo, conto, sottoConto } = clientCode

    const stringCode = `${mastro.padStart(2, '0')}${gruppo.padStart(2, '0')}${conto.padStart(2, '0')}${sottoConto.padStart(6, ' ')}`

    const { data: [client] = [], ok } = await FC.service('info').get('searchClient', {
      query: { codCliente12: stringCode }
    })

    if (!ok || !client) return alert('error', t.errore, t.cpClienteNonTrovato)
    ok &&
      client &&
      setSelectedClient({
        codCliente12: client?.datiGeneraliCliente?.codCliente12,
        ragioneSociale: client?.datiGeneraliCliente?.ragioneSociale
      })

    setRagioneSociale(client?.datiGeneraliCliente?.ragioneSociale)

    const presetExists = await checkPresetEsistente(
      'cliente',
      client?.datiGeneraliCliente?.codCliente12
    )
    if (presetExists) {
      setSelectedClient()
      alert('warn', t.cpPresetEsistente, t.cpClienteConfigurazioneEsistente)
      return navigate('/community/panel/modify/' + presetExists.id)
    }
  }

  const checkPresetEsistente = async (type, codCliente) => {
    const queryParam = type === 'gruppo' ? { codiceGruppo } : { codiceCliente: codCliente }
    const [preset = false] = await FC.service('communityPreset').find({ query: queryParam })

    return preset
  }

  const onChangePresetDefault = (value) => {
    setDefaultPreset(value)
    if (value) {
      setStatePreset(true)
      if (operation !== 'modify') {
        setCodiceGruppo('')
        setDescrizioneGruppo('')
        setGroup()
      }
    }
  }
  const handleSelectApplyType = (type) => {
    setDefaultPreset(false)
    setGroup()
    setSelectedClient()
    setSelectedTypeSearch(type)
  }

  const canSearch = true

  return (
    <>
      <PageHeader
        className="community-page-header"
        title={presetId === 'new' ? t.cpCreaPreset : t.cpModificaPreset}
        subtitle={titolo || undefined}
        actions={
          <>
            <button type="button" className="nbtn" onClick={() => navigate('/community/search')}>
              <i className="pi pi-chevron-left" style={{ fontSize: 14 }} />
              {t.indietro}
            </button>
            {visibilityCondition && (
              <button
                type="button"
                className="nbtn nbtn--primary"
                onClick={save}
                disabled={isSaving}
              >
                <i className="pi pi-check" style={{ fontSize: 14 }} />
                {t.salva}
              </button>
            )}
          </>
        }
      />

      <div className="nsec community-section">
        <div className="nsec__head">
          <div className="nsec__ico">
            <Icon name="settings" size={16} />
          </div>
          <h3 className="nsec__title">{t.impostazioni}</h3>
          <div className="community-header-actions">
            {statePreset && <span className="nbadge nbadge--ok">{t.active}</span>}
            <div className="community-toggle-row">
              <InputSwitch checked={statePreset} onChange={(e) => setStatePreset(e.value)} />
              <span>{statePreset ? t.presetAbilitato : t.inactive}</span>
            </div>
          </div>
        </div>
        <div className="nsec__body">
          {visibilityCondition && (
            <div style={{ marginBottom: 20 }}>
              <div className="nfield">
                <label>
                  {t.titoloPreset} <span className="nfield__req">*</span>
                </label>
                <InputText
                  value={titolo}
                  onChange={({ target: { value } }) => setTitolo(value)}
                  style={{ width: '100%', borderRadius: 8 }}
                />
              </div>
            </div>
          )}

          <div className="nfield">
            <label>{t.applicazionePreset || 'Applicazione'}</label>
            <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
              <button
                type="button"
                className={`npill ${defaultPreset ? 'is-active' : ''}`}
                onClick={() => onChangePresetDefault(true)}
              >
                <i className="pi pi-globe" style={{ fontSize: 13 }} />
                Default
              </button>
              <button
                type="button"
                className={`npill ${!defaultPreset && selectedTypeSearch === 'GR' ? 'is-active' : ''}`}
                onClick={() => handleSelectApplyType('GR')}
                disabled={initialDefaultPreset}
              >
                <i className="pi pi-users" style={{ fontSize: 13 }} />
                {t.chooseClientGroupGroup}
              </button>
              <button
                type="button"
                className={`npill ${!defaultPreset && selectedTypeSearch === 'CL' ? 'is-active' : ''}`}
                onClick={() => handleSelectApplyType('CL')}
                disabled={initialDefaultPreset}
              >
                <i className="pi pi-user" style={{ fontSize: 13 }} />
                {t.chooseClientGroupClient}
              </button>
            </div>
          </div>

          {!defaultPreset && selectedTypeSearch !== '' && (
            <div className="community-search-panel">
              {selectedTypeSearch === 'CL' && (
                <SearchByClient
                  clientCode={[clientCode, setClientCode]}
                  selectedClient={[selectedClient, setSelectedClient]}
                  ragioneSociale={[ragioneSociale, setRagioneSociale]}
                  disabled={!canSearch}
                />
              )}
              {selectedTypeSearch === 'GR' && (
                <SearchByGroup
                  codiceGruppo={[codiceGruppo, setCodiceGruppo]}
                  descrizioneGruppo={[descrizioneGruppo, setDescrizioneGruppo]}
                  disabled={!canSearch}
                  group={[group, setGroup]}
                />
              )}
            </div>
          )}

          {!visibilityCondition &&
            !defaultPreset &&
            selectedTypeSearch === 'GR' &&
            canSearch &&
            selectedTypeSearch !== '' && (
              <div className="community-search-confirm">
                <button type="button" className="nbtn nbtn--primary" onClick={handleSearch}>
                  {t.conferma}
                </button>
              </div>
            )}
        </div>
      </div>
    </>
  )
}

export default HeaderSettings
